import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { MfaScreen } from '@/screens/accounts/SCR-106-107-sso-mfa'

// SCR-107 Two-step sign-in (accounts area).
export const Route = createFileRoute('/_public/mfa')({
  validateSearch: z.object({ next: z.string().max(2000).optional().catch(undefined) }),
  component: function Mfa() {
    return <MfaScreen search={Route.useSearch()} />
  },
})
